module.exports = __webpack_public_path__ + "static/media/rocket.f349106b.svg";